import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import AccountLoginPage from "./pages/AccountLoginPage";
import ApproverPage from "./pages/ApproverPage";
import DistributorBrokeragePage from "./pages/DistributorBrokerage";
import DistributorLoginPage from "./pages/DistributorLoginPage";
import LoginPage from "./pages/LoginPage";
import MasterPage from "./pages/MasterPage";
import NotFound from "./pages/NotFound";
import { Navigate } from "react-router-dom";
import SidebarPro from "./components/Sidebar/SidebarPro";
import { useSidebarContext } from "./components/Sidebar/context/SidebarState";
import SalesListing from "./pages/SalesListing";

import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import DashboardPage from "./pages/Dashboard";
import DistributorMasterPage from "./pages/DistributorMaster";
import DistributorProductMappingPage from "./pages/DistributorProductMapping";
import ProductMappedPage from "./pages/ProductMapped";
import ProductMasterPage from "./pages/ProductMaster";
import RoleMasterPage from "./pages/RoleMasterPage";
import UIConfigurationPage from "./pages/UIConfigurationPage";
import UserMasterPage from "./pages/UserMasterPage";
import FundMasterPage from "./pages/FundMasterPage";
import TransactionPage from "./pages/TransactionPage";
import TransactionFeeMismatch from "./pages/TransactionFeeMismatch";
import TransactionDetails from "./pages/TransactionDetails";
import AdminDashboard from "./pages/AdminDashboard";
import InvoiceUpload from "./pages/InvoiceUpload";
import InvoiceApproval from "./pages/InvoiceApproval";
import Invoice from "./pages/Invoice";
import DistributorDashboard from "./pages/DistributorDashboard";
import SalesDashboard from "./pages/SalesDashboard";
import DigitalOnboardingListing from "./pages/DigitalOnboardingListing";
import TransactionManagement from "./pages/TransactionManagement";
import SalesHeadDashboard from "./pages/SalesHead";
import DistributorListing from "./pages/DistributorListing";
import AMCListing from "./pages/AMCListing";
import TransactionApprovalPage from "./pages/TransactionApprovalPage";
import DistributorCommercialsMapping from "./pages/DistributorCommercialsMapping";

const ProtectedRoute = ({ children }) => {
  const { isMoreSidebar } = useSidebarContext();
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const userId = userDetails?.id || null;
  const userName = userDetails?.name || "";

  if (!userId) return <Navigate to="/" replace />;

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <div
        className={`transition-all duration-300 relative z-[999] ${isMoreSidebar ? "w-[80px]" : "w-[250px]"
          }`}
      >
        <SidebarPro />

      </div>
      <div className="flex flex-col flex-1 min-h-screen relative min-w-0">
        <header className="sticky top-0 z-[1002] bg-white">
          <Header
            userId={userId}
            userName={userName}
            roleId={Number(userDetails?.role_id)}
            roleName={userDetails?.role_name || userDetails?.role}
            arnCode={userDetails?.arn_code || ""}
            panNumber={userDetails?.pan_number || ""}
          />
        </header>
        <main className="flex-1 overflow-y-auto bg-[linear-gradient(180deg,_#F5F5F7_0%,_#FFF_50%,_#F5F5F7_100%)]">
          {children}
        </main>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />{" "}
        <Route
          path="/distributormaster"
          element={
            <ProtectedRoute>
              <MasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usermaster"
          element={
            <ProtectedRoute>
              <UserMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin_dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor-brokerage"
          element={
            <ProtectedRoute>
              <DistributorBrokeragePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Approver"
          element={
            <ProtectedRoute>
              <ApproverPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Account-Login"
          element={
            <ProtectedRoute>
              <AccountLoginPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Distributor-Login"
          element={
            <ProtectedRoute>
              <DistributorLoginPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user_master"
          element={
            <ProtectedRoute>
              <UserMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/role_master"
          element={
            <ProtectedRoute>
              <RoleMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ui_configuration"
          element={
            <ProtectedRoute>
              <UIConfigurationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fund_master"
          element={
            <ProtectedRoute>
              <FundMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor"
          element={
            <ProtectedRoute>
              <DistributorMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product"
          element={
            <ProtectedRoute>
              <ProductMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute>
              <TransactionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction_fee_mismatch"
          element={
            <ProtectedRoute>
              <TransactionFeeMismatch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction_details"
          element={
            <ProtectedRoute>
              <TransactionDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice_upload"
          element={
            <ProtectedRoute>
              <InvoiceUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice_approve"
          element={
            <ProtectedRoute>
              <InvoiceApproval />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice"
          element={
            <ProtectedRoute>
              <Invoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor_dashboard"
          element={
            <ProtectedRoute>
              <DistributorDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor_product_mapping"
          element={
            <ProtectedRoute>
              <DistributorProductMappingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product_mapped"
          element={
            <ProtectedRoute>
              <ProductMappedPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor_commercials_mapping"
          element={
            <ProtectedRoute>
              <DistributorCommercialsMapping />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial_dashboard"
          element={
            <ProtectedRoute>
              <SalesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor_onboarding_form"
          element={
            <ProtectedRoute>
              <Navigate to="/onboarding_listing?tab=form" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding_listing"
          element={
            <ProtectedRoute>
              <DigitalOnboardingListing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction_management"
          element={
            <ProtectedRoute>
              <TransactionManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales_listing"
          element={
            <ProtectedRoute>
              <SalesListing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales_head_dashboard"
          element={
            <ProtectedRoute>
              <SalesHeadDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/amc_listing"
          element={
            <ProtectedRoute>
              <AMCListing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction_approval"
          element={
            <ProtectedRoute>
              <TransactionApprovalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor_listing"
          element={
            <ProtectedRoute>
              <DistributorListing />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
